import { marked } from 'marked';
import React from 'react';
import MdEditor from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';

interface MarkdownEditorProps {
  markdown: string;
  setMarkdown: (markdown: string) => void;
}

const MarkdownEditor = ({ markdown, setMarkdown }: MarkdownEditorProps) => (
  <MdEditor
    value={markdown}
    renderHTML={(text) => marked(text)}
    onChange={({ text }) => setMarkdown(text)}
    style={{ minHeight: '300px' }}
  />
);

export default MarkdownEditor;
